import React from 'react';
import { Link  } from "react-router-dom";
import { Utils } from '../../../Utils';
import Text from '../Text/Text.js';
import Html from '../Html/Html.js';
import Radio from '../Radio/Radio.js';
import Checkbox from '../Checkbox/Checkbox.js';
import Textarea from '../Textarea/Textarea.js';
import Select from '../Select/Select.js';
import i18n from '../../../i18n/i18n.js';
import { ReactSVG } from "react-svg";

import './Form.css';

class Form extends React.Component {

  name = '';
  parent = null;
  submit_text = '';

  emptyFormErrors = {};
  emptyFormData = {};
  propsForm = false;

  constructor(props) {
    
    super(props);

    this.inputRefs = [];
    this.name = typeof props.name != 'undefined' ? props.name : '';
    this.parent = typeof props.parent != 'undefined' ? props.parent : null;
    this.submit_text = typeof props.submit_text != 'undefined' ? props.submit_text : 'OK';
    this.on_save = typeof props.on_save === 'function' ? props.on_save : null;
    this.form_source = typeof props.form_source != 'undefined' ? props.form_source : 'server'; 

    let formData = {};

    if (typeof props.form_data != 'undefined')
    {
      formData = {...props.form_data};
    } 

    this.state = {
      formData: formData,
      formErrors: {},
      webshopParams: {},
      display_success: false,
      submit_disabled: false,
      countdown: null, // pinkód újragenerálásnál használva
    };
  }

  componentDidMount() {
    this.read_webshop_params();
  }

  /**
   * form adatok betöltése
   */
  read_webshop_params() {

    const { formData } = this.state;

    if(this.form_source!=='server')
    {
      this.set_state_from_form_data(formData);
    }
    else
    {
      // regisztrációs form esetén felküldjük az email címet localstorage-ból
      // ha van az email címhez tv kártya akkor a php a tvk checkbox nélkül küldi le a formot
      if (this.name === 'account_create')
      {
        let login_email = Utils.localSorageGetWithExpiry('login_email_' + i18n.resolvedLanguage);

        if (!!login_email)
        {
          formData.login_email = login_email;
        }
      }

      Utils.get_server_data(
        '', 
        {ajax_event: this.name, APICACHE: 'false'}, 
        {ajax_event: this.name, formData: JSON.stringify(formData)}
      )
      .then((res) => {
          this.set_state_from_form_data(res);        
      });
    }

   
  }

  set_state_from_form_data(res)
  {
    const new_state = {
      webshopParams: { ...res.items },
      formErrors: { ...res.messages },
      formData: { ...res.values },
      display_success: this.state.display_success
    }

    if (Object.keys(new_state.webshopParams))
    {
      Object.keys(new_state.webshopParams).forEach(key => {
        const fieldname = new_state.webshopParams[key].fieldname;

        if (typeof new_state.formErrors[fieldname] == 'undefined')
          new_state.formErrors[fieldname] = '';

        if (typeof new_state.formData[fieldname] == 'undefined')
        {
          new_state.formData[fieldname] = new_state.webshopParams[key]?.default;
        }

        // ha vannak alárendelt elemek
        if (typeof new_state.webshopParams[key].items !== 'undefined' && Object.keys(new_state.webshopParams[key].items).length)
        {
          Object.keys(new_state.webshopParams[key].items).forEach(key2 => {
            const fieldname = new_state.webshopParams[key].items[key2].fieldname;

            if (typeof new_state.formErrors[fieldname] == 'undefined')
              new_state.formErrors[fieldname] = '';

            if (typeof new_state.formData[fieldname] == 'undefined')
            {
              new_state.formData[fieldname] = new_state.webshopParams[key].items[key2]?.default;
            }
          });
        }
      });

      this.emptyFormErrors = {...new_state.formErrors};
      this.emptyFormData = {...new_state.formData};
    }

    this.setState(new_state);
  }

  /**
   * form adatok mentése
   */
  handle_submit(event) {

    event.preventDefault();

    const { formData } = this.state;

    if(this.on_save){

      this.on_save(formData);

    } else {
      const after_response = (res) => 
      {
        this.get_xhr_messages(res.messages, () => 
        {
          const { formErrors } = this.state;

          // sikeres mentés után ha a formErrors.summary nem üres akkor kiírjuk sikeres üzenetként
          // a végén mindenképp meghívjuk a formot létrehozó osztály on_submit_success függvényét
          // az egyedi sikeres mentés utáni műveletek elvégzése miatt
          if (parseInt(res.success) === 1)
          {
            const after_hide_success_message = () => 
              typeof this.parent.on_submit_success !== 'undefined' && 
                this.parent.on_submit_success({
                  formData: this.state.formData,
                  result: res
                });

            if (typeof formErrors.summary !== 'undefined' && formErrors.summary.length)
            {
              this.setState({display_success: true, submit_disabled: false}, () => {
                setTimeout(() => {
                  this.setState({display_success: false}, after_hide_success_message);
                }, 1000)
              });
            }
            else {
              after_hide_success_message();
            }
          }
        });
      };

      const get_server_data = () => 
      {
        Utils.get_server_data(
          '', 
          {ajax_event: this.name + '_save', APICACHE: 'false'}, 
          {ajax_event: this.name + '_save', formData: JSON.stringify(formData)}
        )
          .then((res) => {
            this.setState({submit_disabled: false}, () => after_response(res));
          });
      };

      this.setState({submit_disabled: true}, get_server_data);
    }    
  }

  get_xhr_messages(messages, cb = () => {})
  {
    Object.keys(messages).forEach((key) => messages[key] = messages[key].join('<br>'));

    this.setState({formErrors : Object.assign({ ...this.emptyFormErrors }, messages)}, cb);
  }

  handle_change(event, formDataKey, options = {}) {
    const formData = this.state.formData;

    formData[formDataKey] = typeof options.force_value !== 'undefined' ? options.force_value : event.target.value;
    
    if(formDataKey == 'area_code_phone_txt' || formDataKey == 'phone_section_1_phone_txt')
    {
      const str_len = formData[formDataKey].length;
      const is_max_len = (formDataKey=='area_code_phone_txt' && str_len==2) ? true : ((formDataKey=='phone_section_1_phone_txt' && str_len==3) ? true : false);

      if(is_max_len && formDataKey=='area_code_phone_txt')
      {
          if(this.inputRefs['phone_section_1_phone_txt']){
            this.inputRefs['phone_section_1_phone_txt'].focus();
          }
      }
      else if(is_max_len && formDataKey=='phone_section_1_phone_txt')
      {
          if(this.inputRefs['phone_section_2_phone_txt']){
            this.inputRefs['phone_section_2_phone_txt'].focus();
          }
      }
    }

    // ha input[type="number"] és van maxlength, akkor ne lehessen többet beírni
    if (!!options.item && options.item?.number && options.item?.text_maxlength > 0) {
      formData[formDataKey] = formData[formDataKey].substring(0, options.item.text_maxlength);
    }
    
    this.setState({formData});
  }

  render_item_by_type(item) {
    const { formData, formErrors, webshopParams } = this.state;
    let { countdown } = this.state;

    let result = '';
  
    // ha a formData-ban a item.condition.fieldname mező értéke == item.condition.value, akkor az elem megjelenhet a formon, egyébként pedig nem
    // pl. app_checkout.php prepare_checkout_form_items()
    if (item?.condition?.fieldname && item?.condition?.value)
    {
      if (formData[item.condition.fieldname] + '' !== item.condition.value + '') {
        return ;
      }
    }

    // ha a formData-ban a item.conditional_required.fieldname mező értéke == item.condition.value, akkor az elem kötelező a formon, egyébként pedig nem
    // pl. app_checkout.php prepare_checkout_form_items()
    if (item?.conditional_required?.fieldname && typeof item?.conditional_required?.value !== 'undefined')
    {
      if (formData[item.conditional_required.fieldname] + '' == item.conditional_required.value + '') {
        item.required = 1;
      }
    }

    if (item?.conditional_value?.fieldname && item?.conditional_value?.fieldvalue && typeof item?.conditional_value?.value !== 'undefined')
    {
      if (formData[item.conditional_value.fieldname] + '' == item.conditional_value.fieldvalue + '' && typeof item.conditional_value_set === 'undefined') {
        formData[item.fieldname] = item.conditional_value.value;
        item.conditional_value_set = true;
      }
    }

    switch (item['category']) {
      case 'datamask':
        if (typeof item['items'] !== 'undefined')
        {
          result = <div key={item.fieldname} className={`row block ${item.fieldname}`}> 
            <label className="field_label" dangerouslySetInnerHTML={{__html: item.label + (item.required ? ' *' : '')}}></label>
            <div className="block_content">
              {Object.values(item['items'])
                .map(item_lvl_x => this.render_item_by_type(item_lvl_x))} 
            </div>
            <div className="block_error">
              {(formErrors[item.fieldname].length) 
                ? <div className="form_error" dangerouslySetInnerHTML={{__html: formErrors[item.fieldname]}}></div> : '' }
            </div>
          </div>;
        }
        break;
      case 'html':
        result = <Html ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></Html>
        break;
      case 'text':
      case 'hidden':
        
        // a felhasználó e-mail címe megvan localstorage-ban, ez alapján kitöltjük az email cím mezőket
        if (item?.fieldname == 'email_txt')
        {
          let login_email = Utils.localSorageGetWithExpiry('login_email_' + i18n.resolvedLanguage);

          if (!!login_email)
          {
            formData[item.fieldname] = login_email;
          }
        }

        // pinkód mező esetén meg kell jeleníteni a pinkód újragenerálása gombot és a visszaszámlálót
        if (item?.fieldname == 'email_pswpin_code')
        {
          const on_refresh_click = () => {
            if (this.state.countdown <= 0)
            {
              this.setState({countdown: 31}, () => {
                let timer = setInterval(() => {
                    if (--this.state.countdown < 1) 
                    {
                      
                      formData.registration = 1;

                      Utils.get_server_data(
                        '',
                        {
                          ajax_event:'resend_email_pin_code',
                          APICACHE:'false'
                        }, 
                        {
                          ajax_event: 'resend_email_pin_code',
                          formData: JSON.stringify(formData),
                        }
                      );

                      clearInterval(timer);
                    }
    
                    this.setState({countdown: this.state.countdown, webshopParams});
                  }, 1000);
              });
            }
          };

          item.html_after_input = <div className="html_after_input"><ReactSVG onClick={on_refresh_click} className="refresh_icon" src={`assets/images/refresh.svg`}></ReactSVG>{countdown ? <span className="countdown" dangerouslySetInnerHTML={{__html: i18n.t('pinCodeResendText').replace('{x}', countdown)}}></span> : ''}</div>;
        }

        result = <Text ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></Text>
        break;
      case 'radio':
        result = <Radio ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></Radio>
        break;
      case 'checkbox':
        result = <Checkbox ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></Checkbox>
        break;
      case 'textarea':
        result = <Textarea ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></Textarea>
        break;
      case 'listbox':
        result = <Select ref={(input)=>{this.inputRefs[item.fieldname] = input;}} key={item.fieldname} parent={this} ws_data={item}></Select>
        break;
    }

    return result;
  }

  render() {
    const { formErrors, webshopParams, display_success, submit_disabled } = this.state;

    if (!Object.keys(webshopParams).length) return '';

    return <>
      <form onSubmit={(e) => this.handle_submit(e)}>

        {Object.keys(webshopParams).map(key => {
          return typeof webshopParams[key]['category'] !== 'undefined' 
            ? this.render_item_by_type(webshopParams[key]) 
            : '';
        })}
       
        <div className={`row`}>
          <div className={`field`}>
            {(display_success) 
            ? <div className="form_success submit_success" dangerouslySetInnerHTML={{__html: formErrors.summary}}></div> : '' }

              <input disabled={submit_disabled} type="submit" value={this.submit_text} />
          </div>
        </div>

      </form> 
    </>;    
  }
};

export default Form;